import { Stack, Typography } from "@mui/material";
import Item from "../../../Item";
export default function Sensibilidade({ data }) {
  return (
    <Stack>
      <Stack className="template-grid column-4">
        <Item label="Parestesias" text={data.parestesias} />
        <Item label="Disestesias" text={data.disestesias} />
        <Item label="Alodinia" text={data.alodinia} />
        <Stack></Stack>
      </Stack>
      <Typography className="section-title">Avaliação segmentar</Typography>
      <Typography
        className="item-text"
        fontSize="18px !important"
        fontWeight="500 !important"
        mb="15px"
      >
        MID Proximal
      </Typography>
      <Stack className="template-grid column-4">
        <Item label="Vibratória" text={data.MIDProximalVibratoria} />
        <Item label="Cinet-post" text={data.MIDProximalCinetPost} />
        <Item label="Táctil" text={data.MIDProximalTactil} />
        <Item label="Dor" text={data.MIDProximalDor} />
      </Stack>
      <Typography
        className="item-text"
        fontSize="18px !important"
        fontWeight="500 !important"
        mb="15px"
      >
        MID Distal
      </Typography>
      <Stack className="template-grid column-4">
        <Item label="Vibratória" text={data.MIDDistalVibratoria} />
        <Item label="Cinet-post" text={data.MIDDistalCinetPost} />
        <Item label="Táctil" text={data.MIDDistalTactil} />
        <Item label="Dor" text={data.MIDDistalDor} />
      </Stack>
      <Typography
        className="item-text"
        fontSize="18px !important"
        fontWeight="500 !important"
        mb="15px"
      >
        MIE Proximal
      </Typography>
      <Stack className="template-grid column-4">
        <Item label="Vibratória" text={data.MIEProximalVibratoria} />
        <Item label="Cinet-post" text={data.MIEProximalCinetPost} />
        <Item label="Táctil" text={data.MIEProximalTactil} />
        <Item label="Dor" text={data.MIEProximalDor} />
      </Stack>
      <Typography
        className="item-text"
        fontSize="18px !important"
        fontWeight="500 !important"
        mb="15px"
      >
        MIE Distal
      </Typography>
      <Stack className="template-grid column-4">
        <Item label="Vibratória" text={data.MIEDistalVibratoria} />
        <Item label="Cinet-post" text={data.MIEDistalCinetPost} />
        <Item label="Táctil" text={data.MIEDistalTactil} />
        <Item label="Dor" text={data.MIEDistalDor} />
      </Stack>
      <Typography
        className="item-text "
        fontSize="18px !important"
        fontWeight="500 !important"
        mb="15px"
      >
        MSD Proximal
      </Typography>
      <Stack className="template-grid column-4">
        <Item label="Vibratória" text={data.MSDProximalVibratoria} />
        <Item label="Cinet-post" text={data.MSDProximalCinetPost} />
        <Item label="Táctil" text={data.MSDProximalTactil} />
        <Item label="Dor" text={data.MSDProximalDor} />
      </Stack>
      <Typography
        className="item-text "
        fontSize="18px !important"
        fontWeight="500 !important"
        mb="15px"
      >
        MSD Distal
      </Typography>
      <Stack className="template-grid column-4">
        <Item label="Vibratória" text={data.MSDDistalVibratoria} />
        <Item label="Cinet-post" text={data.MSDDistalCinetPost} />
        <Item label="Táctil" text={data.MSDDistalTactil} />
        <Item label="Dor" text={data.MSDDistalDor} />
      </Stack>
      <Typography
        className="item-text"
        fontSize="18px !important"
        fontWeight="500 !important"
        mb="15px"
      >
        MSE Proximal
      </Typography>
      <Stack className="template-grid column-4">
        <Item label="Vibratória" text={data.MSEProximalVibratoria} />
        <Item label="Cinet-post" text={data.MSEProximalCinetPost} />
        <Item label="Táctil" text={data.MSEProximalTactil} />
        <Item label="Dor" text={data.MSEProximalDor} />
      </Stack>
      <Typography
        className="item-text "
        fontSize="18px !important"
        fontWeight="500 !important"
        mb="15px"
      >
        MSE Distal
      </Typography>
      <Stack className="template-grid column-4">
        <Item label="Vibratória" text={data.MSEDistalVibratoria} />
        <Item label="Cinet-post" text={data.MSEDistalCinetPost} />
        <Item label="Táctil" text={data.MSEDistalTactil} />
        <Item label="Dor" text={data.MSEDistalDor} />
      </Stack>
      <Stack className="template-grid column-4">
        <Item label="Disfunção autonômica" text={data.disfuncaoAutonomica} />
        <Item label="Tipo da disfunção" text={data.tipoDisfuncao} />
        <Item label="Qual?" text={data.disfuncaoAutonomicaOutra} />
        <Stack></Stack>
      </Stack>
    </Stack>
  );
}
